import { Card, Space, theme } from 'antd';
import { useMemo } from 'react';
import CustomUserFieldsContainer from './CustomUserFormFieldsContainer';
import StandartUserFieldsContainer from './StandartUserFieldsContainer';

export default function ShowUserFieldsContainer({ userId }: { userId: string }) {
    const {
        token: { marginSM, paddingXS, borderRadius }
    } = theme.useToken();
    const memoizedStandardUserFields = useMemo(
        () => <StandartUserFieldsContainer userId={userId} isActive={false} />,
        [userId]
    );

    return (
        <Space direction="vertical" size="small" className="full-width">
            {memoizedStandardUserFields}
            <Card
                bodyStyle={{ padding: paddingXS * 3 }}
                style={{ borderRadius, border: '1px solid rgba(0, 0, 0, 0.12)', marginBottom: marginSM }}
            >
                <CustomUserFieldsContainer isActive={false} />
            </Card>
        </Space>
    );
}
